<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <div class="superadmin-dashboard-area edit-area">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="registered-product-item w-half">
                            <router-link :to="{name: 'ResellerCustomers'}" class="mb-3 inline-block"
                                ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                            >
                            <h3 class="mb-4">Edit Customer</h3>
                            <ul>
                                <li>
                                    <span class="semibold">First Name</span>
                                    <span><input type="text" v-model="form.fname" name="fname" class="form-control" /></span>
                                </li>

                                <li>
                                    <span class="semibold">Last name</span>
                                    <span><input type="text" v-model="form.lname" name="lname" class="form-control" /></span>
                                </li>

                                <!-- <li>Email: 
                      <span><input type="text" v-model="form.email" name="email" class="form-control" /></span>
                    </li> -->

                                <li v-if="role == 'reseller'">
                                    Company:
                                    <span><input type="text" v-model="form.company" name="company" class="form-control" /></span>
                                </li>

                                <li>
                                    <!-- Address: 
                      <span><input type="text" v-model="form.address" name="address" class="form-control" /></span> -->
                                    <label
                                        ><span class="semibold">Address</span>
                                        <em class="notice">( please select the address from suggestion )</em></label
                                    >
                                    <!-- <span><input type="text" v-model="form.address" name="address" class="form-control" /></span> -->
                                    <span>
                                        <gmap-autocomplete
                                            id="customer_edit_address"
                                            autocomplete="nope"
                                            class="form-control"
                                            large
                                            name="address"
                                            placeholder="your address..."
                                            :select-first-on-enter="true"
                                            :componentRestrictions="{country: ['ZA']}"
                                            @place_changed="setPlace"
                                            @keyup="resetPlace"
                                        >
                                        </gmap-autocomplete>
                                    </span>
                                    <div class="address-info-wrap" v-if="form.address && form.addressDetail && form.addressDetail.province">
                                        <p class="address-info"><span>Province:</span> {{ form.addressDetail.province }}</p>
                                        <p class="address-info"><span>City:</span> {{ form.addressDetail.city }}</p>
                                        <p class="address-info"><span>Suburb:</span> {{ form.addressDetail.suburb }}</p>
                                        <p class="address-info"><span>Postcode:</span> {{ form.addressDetail.postcode }}</p>
                                    </div>
                                </li>
                                <li>
                                    <span class="semibold">Complex/Building + Unit</span>
                                    <span
                                        ><input type="text" v-model="form.complex_building_unit" name="complex_building_unit" class="form-control"
                                    /></span>
                                </li>
                                <li>
                                    <span class="semibold">Mobile</span>
                                    <span><input type="text" v-model="form.mobile" name="mobile" class="form-control" /></span>
                                </li>
                                <li>
                                    <button class="btn btn-secondary with-white-border px-5" @click.prevent="updateResellerCustomer()">UPDATE</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Helpers from '@/helpers/index';

export default {
    name: 'resellerCustomerEdit',
    data() {
        return {
            form: {
                fname: '',
                lname: '',
                // email: '',
                company: '',
                address: '',
                complex_building_unit: '',
                addressDetail: {
                    province: '',
                    city: '',
                    suburb: '',
                    postcode: '',
                    lat: '',
                    lng: ''
                },
                mobile: ''
            },
            role: ''
        };
    },

    mounted() {
        this.fetchDetail();
    },

    methods: {
        async fetchDetail() {
            const self = this;
            const url = `${Env.baseUrl}/reseller/customers/show/${this.$route.params.customer_id}`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.role = res.data.payload.role;

                    for (let key in this.form) {
                        if (
                            key == 'addressDetail' &&
                            !_.isEmpty(res.data.payload.user_metas) &&
                            res.data.payload.user_metas.lat &&
                            res.data.payload.user_metas.lng
                        ) {
                            this.form[key] = {
                                province:
                                    res.data.payload.user_metas && res.data.payload.user_metas.province ? res.data.payload.user_metas.province : '',
                                city: res.data.payload.user_metas && res.data.payload.user_metas.city ? res.data.payload.user_metas.city : '',
                                suburb: res.data.payload.user_metas && res.data.payload.user_metas.suburb ? res.data.payload.user_metas.suburb : '',
                                postcode:
                                    res.data.payload.user_metas && res.data.payload.user_metas.postcode ? res.data.payload.user_metas.postcode : '',
                                lat: res.data.payload.user_metas && res.data.payload.user_metas.lat ? res.data.payload.user_metas.lat : '',
                                lng: res.data.payload.user_metas && res.data.payload.user_metas.lng ? res.data.payload.user_metas.lng : ''
                            };
                        } else {
                            if (key == 'complex_building_unit') {
                                this.form[key] =
                                    res.data.payload.user_metas && res.data.payload.user_metas.complex_building_unit
                                        ? res.data.payload.user_metas.complex_building_unit
                                        : '';
                            } else {
                                this.form[key] = res.data.payload[key];
                            }
                        }
                    }
                    this.$nextTick(() => {
                        if (document.getElementById('customer_edit_address')) {
                            document.getElementById('customer_edit_address').value = self.form.address;
                        }
                    });
                })
                .catch((err) => {});
        },

        async updateResellerCustomer() {
            // there must be lat , lng
            if (!this.form.addressDetail.lat && !this.form.addressDetail.lng) {
                return this.$toasted.global.error({
                    message: 'Please select one of the address from suggestion.'
                });
            }

            const url = `${Env.baseUrl}/reseller/customers/update/${this.$route.params.customer_id}`;
            AuthApis.postApi(url, this.form)
                .then((res) => {
                    this.$toasted.global.success({
                        message: 'Successfully Updated.'
                    });
                })
                .catch((err) => {
                    this.$toasted.global.error({
                        message: err.response ? (err.response.data ? err.response.data.errors[0] : 'Fail.') : 'Please try again later.'
                    });
                });
        },

        /**
         * autocomplete set
         */
        setPlace: async function (addressData) {
            if (_.isEmpty(addressData)) {
                return;
            }
            this.form.address = addressData.formatted_address;
            let province = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_1');
            let city = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'administrative_area_level_2');
            let suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_1');
            if (!suburb) {
                suburb = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'sublocality_level_2');
            }
            let postcode = Helpers.getDetailFromGmapAutoComplete(addressData.address_components, 'postal_code');
            let {lat, lng} = Helpers.getLatLngFromGoogleAutoComplete(addressData);
            this.form.addressDetail = {
                province,
                city,
                suburb,
                postcode,
                lat,
                lng
            };
        },

        resetPlace: function () {
            this.form.address = '';
            this.form.addressDetail = {
                province: '',
                city: '',
                suburb: '',
                postcode: '',
                lat: '',
                lng: ''
            };
        }
    }
};
</script>
